import { GetAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";

const useCustomLogo = () => {
  const setCustomLogo = async () => {
    GetAsync(`${API_GATEWAY}/api/userservice/Organization/configuration`)
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.organizationConfiguration?.customLogoWithBaseURI) {
            localStorage.setItem(
              "customLogo",
              res?.data?.organizationConfiguration?.customLogoWithBaseURI
            );
          }
        } else {
          console.log("Error Fetching Custom Logo", res.data.Detail);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Custom Logo", err);
      });
  };

  return {
    setCustomLogo,
  };
};

export default useCustomLogo;
